import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

/**
 * Inline links to Terms and Privacy for footers (landing, login, widget).
 * @param {{ variant?: 'light' | 'dark' }} props
 */
export default function SiteLegalLinks({ variant = 'light' }) {
  const link =
    variant === 'dark'
      ? 'text-white/70 underline-offset-4 hover:text-white hover:underline'
      : 'text-slate-600 underline-offset-4 hover:text-slate-900 hover:underline';
  return (
    <nav className={cn('flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-sm', variant === 'dark' && 'text-white/60')} aria-label="Legal">
      <Link to="/terms" className={link}>
        Terms of Service
      </Link>
      <span className={variant === 'dark' ? 'text-white/30' : 'text-slate-300'} aria-hidden>
        |
      </span>
      <Link to="/privacy" className={link}>
        Privacy Policy
      </Link>
    </nav>
  );
}
